<div class="program-author-info" *ngIf="authorDetails; let author">
  <div class="body-s author-title">{{ 'translations.summary.title.author' | transloco }}:</div>
  <div class="author-icon-box" *ngIf="author.displayConfig?.authorName || author.displayConfig?.organizationName">
    <ng-container *ngIf="author.displayConfig?.authorName && !author.displayConfig?.organizationName">
      <img
        *ngIf="author.userImageUrl"
        class="author-image"
        width="24"
        height="24"
        alt="{{ author.name }} profile image"
        [src]="author.userImageUrl"
      />
      <div class="author-initials small bold" *ngIf="!author.userImageUrl">
        {{ author.name.charAt(0) }}
      </div>
    </ng-container>
    <ng-container *ngIf="author.displayConfig?.organizationName">
      <img
        class="author-image"
        width="24"
        height="24"
        alt="{{ author.displayConfig.externalAuthor?.name }} logo"
        *ngIf="author.orgLogoUrl"
        [src]="author.orgLogoUrl"
      />
      <div class="author-initials small bold" *ngIf="!author.orgLogoUrl">
        {{ author.displayConfig.externalAuthor?.name.charAt(0) }}
      </div>
    </ng-container>
  </div>
  <ng-container></ng-container>
  <div class="author-name-box" *ngIf="author?.displayConfig?.authorName || author?.displayConfig?.organizationName">
    <span class="author-name body-s bold" *ngIf="author?.displayConfig?.authorName && !author?.displayConfig?.organizationName">{{
      author.name
    }}</span>
    <span class="author-name body-s bold" *ngIf="!author?.displayConfig?.authorName && author?.displayConfig?.organizationName">{{
      author?.organization
    }}</span>
    <span class="author-name body-s bold" *ngIf="author?.displayConfig?.authorName && author?.displayConfig?.organizationName"
      >{{ author?.organization }} |
      <em>{{ author.name }}</em>
    </span>
  </div>
</div>
